import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const BasindaBizPage = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

  const videos = [
    { id: 'dOLFGbHQ_po', title: 'Video 1' },
    { id: 'SR8U5medesg', title: 'Video 2' },
    { id: '718kthH4YeM', title: 'Video 3' },
    { id: '_dlkOQHFBqo', title: 'Video 4' },
    { id: 'XCL3I_NzW4s', title: 'Video 5' },
    { id: 'n4AavT9gRQk', title: 'Video 6' },
    { id: 'fmowbXTgIlg', title: 'Video 7' },
    { id: 'j9Plm4qEyYM', title: 'Video 8' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Hero Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="font-serif text-5xl lg:text-6xl font-bold text-primary-dark mb-6">
              Basında Biz
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Medyada yer alan haberlerimiz, röportajlarımız ve basın yansımalarımız
            </p>
          </motion.div>

          {/* Videos Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="font-serif text-3xl font-bold text-primary-dark mb-8 text-center">
              Videolar
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {videos.map((video, index) => (
                <motion.div
                  key={video.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="group cursor-pointer"
                  onClick={() => setSelectedVideo(video.id)}
                >
                  <div className="relative aspect-video rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                      <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                        <i className="ri-play-fill text-3xl text-white"></i>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />

      {/* Video Modal */}
      {selectedVideo && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setSelectedVideo(null)}
        >
          <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.9 }}
            className="w-full max-w-6xl aspect-video"
            onClick={(e) => e.stopPropagation()}
          >
            <iframe
              src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full rounded-lg"
            ></iframe>
          </motion.div>
          
          <button
            onClick={() => setSelectedVideo(null)}
            className="absolute top-8 right-8 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer"
            aria-label="Kapat"
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
        </motion.div>
      )}

      {/* WhatsApp Floating Button */}
      <motion.a
        href="https://wa.me/905366460317"
        target="_blank"
        rel="nofollow noopener noreferrer"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform duration-300 z-50 cursor-pointer"
        style={{ animation: 'pulse 2s infinite' }}
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </motion.a>

      <style>{`
        @keyframes pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
          50% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
        }
      `}</style>
    </div>
  );
};

export default BasindaBizPage;